import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    elements: [],
    explainerElements: [],
    explainerLookup: []
}

export const explainerSlice = createSlice({
    name: "explainer",
    initialState,
    reducers: {
        setExplainerElements: (state, action) => {
            state.explainerElements = action.payload;
        },
        setElements: (state, action) => {
            state.elements = action.payload;
        },
        setExplainerLookup: (state, action) => {
            state.explainerLookup = action.payload;
        }
    }
});

//SETTER: set values to variables
export const {
    setElements,
    setExplainerElements,
    setExplainerLookup
} = explainerSlice.actions;

export const explainerData = (state)=>state.explainer;
export default explainerSlice.reducer;